import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { CardState } from '../../types';

export const Wrapper = styled(Link)`
  border: 1px solid ${({ theme }) => theme.colors.neutralColors.lightestGray};
  border-radius: 8px;
  padding: 8px;
  background: ${({ theme }) => theme.colors.neutralColors.white};
  display: flex;
  text-decoration: none;
  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.brandColors.coral};
    box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.brandColors.coral};
  }
`;

export const StyledTagContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.colors.neutralColors.charcoal};
  border-radius: 100%;
`;

export const StyledImageWrapper = styled.div<{ state: CardState }>`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
  filter: blur(0);
  ${({ theme }) => theme.breakPoints.desktop} {
    height: 120px;
    width: 120px;
  }
  &:before {
    content: '';
    position: absolute;
    display: ${({ state }) => (state === 'not started' ? 'none' : 'block')};
    bottom: 0;
    right: ${({ state }) => (state === 'complete' ? 0 : '50%')};
    height: 4px;
    width: 100%;
    background: ${({ theme }) => theme.colors.brandColors.coral};
  }
  &:after {
    content: '';
    position: absolute;
    display: ${({ state }) => (state === 'in progress' ? 'block' : 'none')};
    bottom: 0;
    left: 50%;
    height: 4px;
    width: 100%;
    backdrop-filter: blur(8px);
  }
`;
export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StyledVideoPlayButton = styled.div`
  height: 32px;
  width: 32px;
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translateY(-50%) translateX(50%);
  backdrop-filter: blur(8px);
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.breakPoints.desktop} {
    height: 48px;
    width: 48px;
  }
`;

export const TextWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 16px;
`;
export const StyledLabel = styled.p`
  font-size: 1.2rem;
  line-height: 2.4rem;
  text-transform: uppercase;
  font-family: 'Moderat Bold';
  color: ${({ theme }) => theme.colors.textColors.secondaryDark};
  margin-bottom: 8px;
`;

export const StyledTitle = styled.h3`
  font-size: 1.8rem;
  line-height: 2.4rem;
  font-family: 'Moderat';
  color: ${({ theme }) => theme.colors.textColors.primaryDark};

  ${({ theme }) => theme.breakPoints.desktop} {
    display: block;
    margin-bottom: 8px;
  }
`;

export const StyledDescription = styled.p`
  color: ${({ theme }) => theme.colors.textColors.secondaryDark};
  font-size: 1.4rem;
  line-height: 2rem;
  display: none;
  ${({ theme }) => theme.breakPoints.desktop} {
    display: block;
  }
`;
